var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5a9 9 0 1 0 15.646-6.069l-.206-.215a.749.749 0 0 0-1.278.533c0 .179.063.343.168.472l.034.037q.567.58.998 1.269a7.5 7.5 0 1 1-10.86-2.029v2.756a.75.75 0 0 0 1.493.102l.007-.102V3.75a.75.75 0 0 0-.648-.743L8.252 3h-4.5a.75.75 0 0 0-.102 1.493l.102.007h2.59A8.99 8.99 0 0 0 3 11.5"
  })));
};
export default SvgRefresh;